module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.support', {
            url: '/support',
            views: {
                'left-panel@shop': {
                    template: '<wow-accessibility-nav-links></wow-accessibility-nav-links>',
                },
            },
            data: {
                authenticate: false,
            },
        })
        .state('shop.support.accessibility', {
            url: '/accessibility',
            views: {
                'center-panel@shop': {
                    template: '<wow-shopper-accessibility></wow-shopper-accessibility>',
                },
            },
            data: {
                authenticate: false,
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/accessibility.js